import React from "react";

const formatDate = (date) => {
  if (!date) return "";

  const d = new Date(date);

  return d.toLocaleString("en-US", {
    month: "2-digit",
    day: "2-digit",
    hour: "numeric",
    minute: "2-digit",
    hour12: true
  });
};

const parseCards = (cards) => {
  if (!cards) return [];

  return cards
    .split(",")
    .map((card) => card.trim())
    .filter(Boolean);
};

const QueenRaceResult = ({ resultData = [] }) => {

  return (
    <div className="left-content">

      {resultData.map((row, index) => {

        const players = [
          {
            label: row.cat_rnr1 || "Total 0",
            cards: parseCards(row.c1),
            winner: row.result === "1" || row.result === 1
          },
          {
            label: row.cat_rnr2 || "Total 1",
            cards: parseCards(row.c2),
            winner: row.result === "2" || row.result === 2
          },
          {
            label: row.cat_rnr3 || "Total 2",
            cards: parseCards(row.c3),
            winner: row.result === "3" || row.result === 3
          },
          {
            label: row.cat_rnr4 || "Total 3",
            cards: parseCards(row.c4),
            winner: row.result === "4" || row.result === 4
          }
        ];

        return (

          <div
            key={index}
            style={{
              border: "1px solid #ccc",
              borderRadius: "8px",
              padding: "9px",
              marginBottom: "10px",
              background:
                "linear-gradient(rgb(15,15,15), rgb(251,251,251))",
              color: "#fff"
            }}
          >

            {/* Header */}

            <div
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                marginLeft: "14px",
                marginBottom: "10px",
                borderBottom: "1px solid rgba(0,0,0,.25)",
                paddingBottom: "8px", paddingTop: "10px"
              }}
            >
              {formatDate(row.evt_od)} - ID= {row.evt_id}
            </div>

            {/* Players */}

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: "2px"
              }}
            >

              {players.map((player, i) => (

                <div
                  key={i}
                  style={{
                    gridColumn: i === 3 ? "1 / -1" : "auto",

                    borderRadius: "14px",
                    overflow: "hidden",

                    background: player.winner
                      ? "green"
                      : "linear-gradient(#555,#181818)"
                  }}
                >

                  <div
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "16px",
                      marginBottom: "3px"
                    }}
                  >
                    {player.label}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "4px",
                      minHeight: "10px",
                      padding: "2px"
                    }}
                  >

                    {player.cards.map((card, idx) => (

                      <img
                        key={idx}
                        src={`/assets/images/cards/${card}.svg`}
                        alt={card}
                        draggable={false}
                        style={{
                          width: "42px"
                        }}
                      />

                    ))}

                  </div>

                  <div
                    style={{
                      background: player.winner
                        ? "#cf8d2e"
                        : "#cf3f3f",
                      color: "#000",
                      textAlign: "center",
                      fontWeight: "bold",
                      borderRadius: "10px",
                      marginTop: "5px",
                      fontSize: "14px"
                    }}
                  >
                    {player.winner
                      ? "WINNER"
                      : "LOSER"}
                  </div>

                </div>

              ))}

            </div>

          </div>

        );

      })}

    </div>
  );
};

export default QueenRaceResult;